export default "__VITE_ASSET__kLqDHlBm__"